import { BaseEntity } from '../../models';
import { Pessoa } from '../pessoa';
import { Cliente } from '../pessoa/cliente/cliente';
import { Representante } from '../pessoa/representante';
import { CondicaoPagamento } from '../condicao-pagamento';
import { FormaPagamento } from '../forma-pagamento';
import { TituloReceberPagamento } from './pagamento';
import { LocalFaturamento } from '../local-faturamento';
export class TituloReceber implements BaseEntity {
    readonly id: number;
    createdAt: Date;
    idUsuarioCreated: number;
    updatedAt: Date;
    idUsuarioUpdated: number;
    idEmpresa: number;
    idPeriodoEmissao: number;
    dataEmissao: Date;
    mesEmissao: number;
    trimestreEmissao: number;
    semestreEmissao: number;
    anoEmissao: number;
    idPeriodoVencimento: number;
    dataVencimento: Date;
    mesVencimento: number;
    trimestreVencimento: number;
    semestreVencimento: number;
    anoVencimento: number;
    idPeriodoUltimoPagamento: number;
    dataUltimoPagamento: Date;
    mesUltimoPagamento: number;
    trimestreUltimoPagamento: number;
    semestreUltimoPagamento: number;
    anoUltimoPagamento: number;
    idPeriodoDevolucao: number;
    dataDevolucao: Date;
    situacao: number;
    numeroNotaFiscal: number;
    serieNotaFiscal: string;
    idPessoa: number;
    pessoa: Pessoa;
    idRepresentante: number;
    representante: Representante;
    idCondicaoPagamento: number;
    condicaoPagamento: CondicaoPagamento;
    idFormaPagamento: number;
    formaPagamento: FormaPagamento;
    /** Nome da forma de pagamento no ERP para quando não houver integração da forma de pagamento */
    nomeFormaPagamentoErp: string;
    valor: number;
    valorJuros: number;
    valorMulta: number;
    valorAcrescimo: number;
    valorDesconto: number;
    valorDevolucao: number;
    valorRenegociado: number;
    valorPago: number;
    valorSaldo: number;
    valorAdimplencia: number;
    percAdimplencia: number;
    anotacao: string;
    anotacaoFinanceira: string;
    idLocalFaturamento: number;
    localFaturamento: LocalFaturamento;
    pagamentos: TituloReceberPagamento[];

    // Atualização Financeira
    dataAtualizacaoFinanceira: Date;
    idUsuarioAtualizacaoFinanceira: number;

    // Integração ERP
    idIntegracaoErp: number;
    numeroErp: string;
    codigoIntegracaoErp: string;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    // Auxiliares
    diasEmAtraso: number;

    idCliente: number; // Atributos auxiliares
    cliente: Cliente;

    constructor(idEmpresa: number) {
        this.idEmpresa = idEmpresa;
        this.pagamentos = [];
    }
}
